<template>
  <a-float-button
    :class="bem.b()"
    v-bind="attrs"
    :shape="shape"
    :description="shape === 'circle' ? '' : description"
    :badge="enableBadge ? badge : undefined"
  >
    <template
      v-for="item in Object.keys($slots).filter((key) => key !== 'icon')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template v-if="icon.iconName || $slots.icon" #icon>
      <slot name="icon">
        <ll-icon v-bind="icon" />
      </slot>
    </template>
  </a-float-button>
</template>
<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import { floatButtonProps } from './float-button'

// 1.defineOptions
defineOptions({ name: 'LlFloatButton' })

const attrs = useAttrs()

const bem = createNamespace('float-button')

defineProps(floatButtonProps)
</script>
